<div class="row mt-3" [formGroup]="form">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-detail">
        <div class="float-start" i18n>Kinder (auch Kinder über 18 Jahre)</div>
        <div *ngIf="deletable" class="float_right">
          <div (click)="triggerDelete()" i18n>Kind aus dem Datensatz entfernen</div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindNachname{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('familienname')">Familienname:</label>
              <input id="AntragKindNachname{{this.getUniqueSuffix()}}" type="text" appToUpperCase [attr.maxlength]="getMaxLength('familienname')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['familienname'])" formControlName="familienname"
                     [ngbPopover]="popFamilienname"
                     appSaveLastFocussed
              >
              <ng-template #popFamilienname>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Familiennamen des Kindes ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindVorname{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('vorname')">Vorname(n):</label>
              <input id="AntragKindVorname{{this.getUniqueSuffix()}}" type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorname')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorname'])" formControlName="vorname"
                     [ngbPopover]="popVorname"
                     appSaveLastFocussed
              >
              <ng-template #popVorname>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den/die Vornamen des Kindes ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindGeschlecht{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('geschlecht')">Geschlecht:</label>
              <select id="AntragKindGeschlecht{{this.getUniqueSuffix()}}" class="form-select form-select-sm"
                      [class.is-invalid]="errorClassRequired(form.controls['geschlecht'])" formControlName="geschlecht"
                      [ngbPopover]="popGeschlecht"
                      appSaveLastFocussed
              >
                <ng-template #popGeschlecht>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte wählen Sie hier das Geschlecht des Kindes aus.</span>
                  </app-assistant>
                </ng-template>
                <option value="" selected></option>
                <option *ngFor="let listItem of geschlechtListItems"
                        value="{{ listItem.key }}">{{ listItem.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindGebDatum{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('geburtsdatum')">Geburtsdatum:</label>
              <input id="AntragKindGebDatum{{this.getUniqueSuffix()}}"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('geburtsdatum')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['geburtsdatum'])" formControlName="geburtsdatum"
                     [ngbPopover]="popGeburtsdatum"
                     appSaveLastFocussed
              >
              <ng-template #popGeburtsdatum>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier das Geburtsdatum des Kindes im Format TT.MM.JJJJ ein. Texteingaben in lateinischer Schrift (Deutsch/Englisch) sind möglich, falls das genaue Datum nicht bekannt sein sollte.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindGebOrt{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('geburtsort')">Geburtsort:</label>
              <input id="AntragKindGebOrt{{this.getUniqueSuffix()}}" type="text" appToUpperCase [attr.maxlength]="getMaxLength('geburtsort')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['geburtsort'])" formControlName="geburtsort"
                     [ngbPopover]="popGeburtsort"
                     appSaveLastFocussed
              >
              <ng-template #popGeburtsort>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Geburtsort (Stadt, Land) des Kindes ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindWohnort{{this.getUniqueSuffix()}}" i18n [class.mandatory]="isMandatory('wohnort')">Wohnort:</label>
              <input id="AntragKindWohnort{{this.getUniqueSuffix()}}" type="text" appToUpperCase [attr.maxlength]="getMaxLength('wohnort')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['wohnort'])" formControlName="wohnort"
                     [ngbPopover]="popWohnort"
                     appSaveLastFocussed
              >
              <ng-template #popWohnort>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Wohnort (Stadt, Land) des Kindes ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="AntragKindStaatsangehoerigkeit1{{this.getUniqueSuffix()}}" i18n>Derzeitige Staatsangehörigkeit:</label>
              <span>
                <select id="AntragKindStaatsangehoerigkeit1{{this.getUniqueSuffix()}}"
                        class="form-select form-select-sm mb-2"
                        [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeit1'])"
                        formControlName="staatsangehoerigkeit1"
                        [ngbPopover]="popStaatsangehoerigkeit1"
                        appSaveLastFocussed
                >
                  <option value="">---</option>
                  <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                </select>
                 <ng-template #popStaatsangehoerigkeit1>
                   <app-assistant (assistantDisabled)="disableAssistant()">
                     <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des Kindes aus.</span>
                   </app-assistant>
                 </ng-template>
              </span>
              <span>
                <select *ngIf="form.value.staatsangehoerigkeit1"
                        id="AntragKindStaatsangehoerigkeit2{{this.getUniqueSuffix()}}"
                        class="form-select form-select-sm mb-2"
                        formControlName="staatsangehoerigkeit2"
                        [ngbPopover]="popStaatsangehoerigkeit2"
                        appSaveLastFocussed
                >
                  <option value="">---</option>
                  <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                </select>
                <ng-template #popStaatsangehoerigkeit2>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des Kindes aus.</span>
                  </app-assistant>
                </ng-template>
              </span>
              <span>
                <select *ngIf="form.value.staatsangehoerigkeit2"
                        id="AntragKindStaatsangehoerigkeit3{{this.getUniqueSuffix()}}"
                        class="form-select form-select-sm mb-2"
                        formControlName="staatsangehoerigkeit3"
                        [ngbPopover]="popStaatsangehoerigkeit3"
                        appSaveLastFocussed
                >
                  <option value="">---</option>
                  <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                </select>
                 <ng-template #popStaatsangehoerigkeit3>
                   <app-assistant (assistantDisabled)="disableAssistant()">
                     <span i18n>Bitte wählen Sie hier die derzeitige Staatsangehörigkeit des Kindes aus.</span>
                   </app-assistant>
                 </ng-template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
